import { getOrganizationApplicationTemplates } from 'admin/actions/merchant-application-templates';
import BreadCrumb from 'admin/components/molecules/BreadCrumb';
import { toQueryParams } from 'admin/utils';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { Button } from '../../atoms/Buttons';
import ListTable from './ListTable';

type GetOrganizationApplicationTemplatesResponse = Awaited<
  ReturnType<typeof getOrganizationApplicationTemplates>
>;

const Wrapper = styled.div``;

const Row = styled.div`
  padding: 10px 0;
`;

const CRUMBS = [
  { value: 'ホーム', href: '/', isCurrentPage: false },
  { value: '決済加盟店管理', href: '', isCurrentPage: true },
  { value: '加盟店申込フォーム', href: '', isCurrentPage: true },
];

const MerchantApplicationTemplates = () => {
  const [applications, setApplications] =
    useState<GetOrganizationApplicationTemplatesResponse | null>(null);

  useEffect(() => {
    getOrganizationApplicationTemplates(toQueryParams({ page: 1 }, true)).then((res) => {
      setApplications(res);
    });
  }, []);

  const onChangePage = (page: number) => {
    getOrganizationApplicationTemplates(toQueryParams({ page }, true)).then((res) => {
      setApplications(res);
    });
  };

  return (
    <Wrapper>
      <BreadCrumb crumbs={CRUMBS} />
      <Row>
        <Link to="/organizations/application-form/create">
          <Button type="button">新規作成</Button>
        </Link>
      </Row>
      {applications != null ? (
        <ListTable
          applications={applications.rows}
          pagination={applications.pagination}
          onChangePage={onChangePage}
        />
      ) : null}
    </Wrapper>
  );
};

export default MerchantApplicationTemplates;
